<template>
  <div>
    <a-tabs class="goods_tabs" type="card" @change="callback">
      <a-tab-pane v-for="item in tabsList" :key="item.key" :tab="item.label">
        <component :is="item.component" :ref="item.component" :check-tab="checkTab"></component>
      </a-tab-pane>
  </a-tabs>
  </div>
</template>

<script>
import {postTrack} from '@/utils/point'
import planTable from './components/planTable/indexIframe.vue'
import importPlan from './components/importPlan/index.vue'

  export default {
    name:"InventoryManage",
    components:{
    },
    data(){
      return {
        checkTab:'planTable',
        tabsList: [
        {
          key: 'planTable',
          label: '计划单',
          component: planTable,
        },
        {
          key: 'planImport',
          label: '计划单导入',
          component: importPlan,
        }
      ],
      }
    },
    created(){
      this.checkTab='planTable'
      postTrack('订单-仓配计划单-计划单列表')
    },
    methods:{
      callback(value){
        this.checkTab=value;
        postTrack(`订单-仓配计划单-仓配计划单导入`)
      },
    }
  }
</script>

<style lang="less" scoped>
.goods_tabs {
  /deep/.ant-tabs-bar{
    margin: 0;
    .ant-tabs-tab {
      height: 48px;
      width: 106px;
      line-height: 48px;
      text-align: center;
    }
  }
  /deep/.ant-tabs-nav-container {
    height: 48px !important;
  }
}
</style>
